import { InjectDebugLogger } from '../../framework/logging/decorators/InjectDebugLogger';
import { LogFormat } from '../../framework/logging/decorators/LogFormat';
import { LogMethod } from '../../framework/logging/decorators/LogMethod';

import ObjectStorage from './ObjectStorage';

@InjectDebugLogger('localStorage')
export class LocalStorageObjectStorage implements ObjectStorage<string> {
  private readonly IDX_SEPARATOR = ';';
  private readonly idxKey: string;
  private idx: string[];

  constructor(
    private readonly keyPrefix: string,
    private readonly maxCapacity: number
  ) {
    this.idxKey = keyPrefix + '$$Index';
    const idx = localStorage.getItem(this.idxKey);
    if (idx !== null) {
      this.idx = idx.split(this.IDX_SEPARATOR);
    } else {
      this.idx = [];
    }
  }

  private itemKey(key: string): string {
    return this.keyPrefix + '$$' + key;
  }

  private saveIndex() {
    localStorage.setItem(this.idxKey, this.idx.join(this.IDX_SEPARATOR));
  }

  @LogMethod
  open(): void {
    // not implemented
  }

  @LogMethod
  async get(@LogFormat('%s') key: string): Promise<string | undefined> {
    return localStorage.getItem(this.itemKey(key)) ?? undefined;
  }

  @LogMethod
  async set(
    @LogFormat('%s') key: string,
    @LogFormat('%o') value: string
  ): Promise<void> {
    if (!this.idx.includes(key)) {
      this.idx.unshift(key);
      const deleted = this.idx.splice(this.maxCapacity);
      deleted.forEach(i => localStorage.removeItem(this.itemKey(i)));
      this.saveIndex();
    }
    localStorage.setItem(this.itemKey(key), value);
  }

  @LogMethod
  async delete(@LogFormat('%s') key: string): Promise<void> {
    const itemIdx = this.idx.indexOf(key);
    if (itemIdx > -1) {
      this.idx.splice(itemIdx, 1);
      this.saveIndex();
    }
    localStorage.removeItem(this.itemKey(key));
  }

  @LogMethod
  async deleteAll(): Promise<void> {
    this.idx.forEach(i => localStorage.removeItem(this.itemKey(i)));
    this.idx = [];
    this.saveIndex();
  }
}
